module.exports = __webpack_public_path__ + "img/welcome.84f1add0.png";